// extracted by mini-css-extract-plugin
module.exports = {"verify":"Verify_verify__lCb_N","text":"Verify_text___FakT","benefits":"Verify_benefits__cBVRh","mitIDButton":"Verify_mitIDButton__bwrMm","closeButton":"Verify_closeButton__Nj1Oa"};